module.exports = __webpack_public_path__ + "static/media/background5.acc5c5d2.jpg";